import { forwardRef, Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root',
  useExisting: forwardRef(() => SetupBarStore),
})
export abstract class SetupBarService {
  public abstract title: string
  public abstract percentComplete: number
  public abstract setAttributes(atts: {
    title?: string
    percentComplete?: number
  }): void
}

@Injectable({
  providedIn: 'root'
})
export class SetupBarStore implements SetupBarService {
  private _title = ''
  private _percentComplete = 0

  public get title(): string {
    return this._title
  }

  public get percentComplete(): number {
    return this._percentComplete
  }

  public set title(t: string) {
    setTimeout(() => this._title = t)
  }

  public set percentComplete(n: number) {
    setTimeout(() => this._percentComplete = n)
  }

  public setAttributes(atts: {
    title?: string
    percentComplete?: number
  }): void {
    if (atts.title !== undefined) this.title = atts.title
    if (atts.percentComplete !== undefined) this.percentComplete = atts.percentComplete
  }
}
